export default __webpack_public_path__ + "img/a96209034e4ef9135a6be823f5614b23.png";